import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import PruTable from 'src/app/common/components/PruTable/PruTable';

import { BulkUploadFailedItem } from 'src/app/modules/pruwallet/types/bulk-upload-types';

type BulkUploadFailedListProps = {
  isLoading: boolean;
  bulkUploadFailedList?: BulkUploadFailedItem[];
};

const BulkUploadFailedList: FC<BulkUploadFailedListProps> = ({ isLoading, bulkUploadFailedList }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  return (
    <>
      <PruTable
        title={Translation('pulseleads.bulkUpload.common.failedList')}
        disableBulkSelect
        operationDef={[]}
        columnDef={[
          {
            isId: true,
            hidden: true,
            keyIndex: 'awardId',
            displayName: '',
            renderData: (row) => '',
          },
          {
            keyIndex: 'csvRowNumber',
            displayName: Translation('pulseleads.bulkUpload.common.rowNumber'),
            renderData: (row) => (row.row ? row.row.toString() : '-'),
          },
          {
            keyIndex: 'failureReason',
            displayName: Translation('pulseleads.bulkUpload.common.failureReason'),
            renderData: (row) => row.error || '-',
          },
        ]}
        isLoading={isLoading}
        dataSource={bulkUploadFailedList ?? []}
        disablePagination
        disableRefresh
      />
    </>
  );
};

export default BulkUploadFailedList;
